import useFetchSingleChallenge from '@pages/challengeGroups/challenge/_hooks/useFetchSingleChallenge';
import Breadcrumb from '@components/breadcrumb/Breadcrumb';
import DataCheck from 'lib/src/components/common/DataCheck';
import Description from 'lib/src/components/typography/Description';
import Title from 'lib/src/components/typography/Title';
import { isEmpty } from 'lib/src/utils/generic';
import { useParams } from 'react-router-dom';
import { editAssessmentBreadcrumbs } from '../../../../../constants/breadcrumbItems';
import useFetchSubmission from '../../hooks/useFetchSubmission';
import useFetchAssessment from '../hooks/useFetchAssessment';

import EditAssessmentForm from './EditAssessmentForm';

interface Params {
    id: string;
}

const EditAssessment = () => {
    const { id } = useParams<Params>();

    const {
        submission,
        isFetching: submissionIsFetching,
        fetchError: submissionFetchError,
    } = useFetchSubmission(parseInt(id));

    const {
        challenge: assessmentChallenge,
        isFetching: assessmentChallengeIsFetching,
        fetchError: assessmentChallengeFetchError,
    } = useFetchSingleChallenge(submission?.challengeID);

    const {
        assessment,
        isFetching: assessmentIsFetching,
        fetchError: assessmentFetchError,
    } = useFetchAssessment(submission?.id);

    editAssessmentBreadcrumbs[2].name =
        assessmentChallenge == null ? 'Loading' : assessmentChallenge.name;
    editAssessmentBreadcrumbs[2].link = `/assessments/submissions/${assessmentChallenge?.id || ''}`;

    return (
        <DataCheck
            dataExists={
                !isEmpty(assessment) && !isEmpty(submission) && !isEmpty(assessmentChallenge)
            }
            isFetching={
                submissionIsFetching || assessmentChallengeIsFetching || assessmentIsFetching
            }
            error={submissionFetchError || assessmentFetchError || assessmentChallengeFetchError}
        >
            <Breadcrumb items={editAssessmentBreadcrumbs} />
            <Title>Edit Assessment</Title>
            <Description>Editing assessment of submission by {submission.companyName}</Description>

            <EditAssessmentForm submission={submission} assessment={assessment} />
        </DataCheck>
    );
};

export default EditAssessment;
